// extracted by mini-css-extract-plugin
module.exports = {"highlightedItem":"highlighted-card_highlightedItem__jkYyT","recommended":"highlighted-card_recommended__8MRwL"};